import UsersSelect from './UsersSelect';

export default UsersSelect;